import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { handleUpdateBandData } from "../BandEditPage"
import { Band } from "../../types/bands"

interface PetFriendlyProps {
  band: Band
}

interface SelectOption {
  value: string | null
  label: string
}

interface ApiResponse {
  success: boolean
  errors?: {
    error: string
  }
}

export const PetFriendly: React.FC<PetFriendlyProps> = ({ band }) => {
  const customOnSubmit = async (
    data: Record<string, any>,
  ): Promise<ApiResponse> => {
    // data will be { additional_info: { pet_friendly: value } } from EditBandFormField
    return (await handleUpdateBandData(band.id, {
      additional_info: { pet_friendly: data.additional_info?.pet_friendly || null },
    })) as ApiResponse
  }

  const options: SelectOption[] = [
    { value: null, label: "Select pet friendly status..." },
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
    { value: "service_animals_only", label: "Service Animals Only" },
  ]

  const fieldData = {
    field: "additional_info.pet_friendly",
    name: "petFriendly",
    label: "Pet Friendly",
    placeholder: "Select pet friendly status",
    required: false,
  }

  return (
    <EditBandFormField
      type="select"
      fieldData={fieldData}
      bandId={band.id}
      options={options}
      onSubmit={customOnSubmit}
    />
  )
}

